class QuantityBreaks extends HTMLElement {
  constructor() {
    super();

    this.default_quantity_selected = null;
    this.quantity_break_items = null;
  }

  connectedCallback() {
    this.default_quantity_selected = this.dataset.quantitySelectedByDefault || 1;
    this.quantity_break_items = this.querySelectorAll('[data-ref="quantity-break-item"]');

    // Attendre que tout soit chargé avant d'initialiser
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.initialize();
      });
    } else {
      // DOM déjà chargé
      this.initialize();
    }

    // Écouter les changements de variante
    document.addEventListener('variant:changed', this.onVariantUpdated.bind(this));
  }

  initialize() {
    this.updateDefaultQuantitySelected();

    this.quantity_break_items.forEach((quantity_break) => {
      quantity_break.addEventListener('click', () => {
        this.selectQuantity(quantity_break);
      });
    });

    // Déclencher l'événement si nécessaire
    if (this.getSelectedQuantity() && this.getSelectedQuantity().dataset.quantity != 1) {
      this.dispatchQuantityUpdateEvent();
    }
  }

  updateDefaultQuantitySelected() {
    this.resetSelectedQuantity();
    if (this.quantity_break_items[this.default_quantity_selected - 1]) {
      const defaultItem = this.quantity_break_items[this.default_quantity_selected - 1];
      defaultItem.classList.add('quantity-break--selected');

      // Activer l'input hidden de l'item par défaut
      this.updateProductQuantity(defaultItem);
    }
  }

  selectQuantity(quantity_break) {
    this.resetSelectedQuantity();
    quantity_break.classList.add('quantity-break--selected');

    // Activer l'input hidden de cet item
    this.updateProductQuantity(quantity_break);

    this.dispatchQuantityUpdateEvent();
  }

  updateProductQuantity(selectedItem) {
    // Désactiver tous les inputs hidden des quantity breaks
    this.quantity_break_items.forEach((item) => {
      const hiddenInput = item.querySelector('.quantity-break-hidden-input');
      if (hiddenInput) {
        hiddenInput.disabled = true;
      }
    });

    // Activer l'input hidden de l'item sélectionné
    const selectedHiddenInput = selectedItem.querySelector('.quantity-break-hidden-input');
    if (selectedHiddenInput) {
      selectedHiddenInput.disabled = false;
      console.log('Quantity break activated with quantity:', selectedHiddenInput.value);
    }

    // Désactiver l'input de quantité standard s'il existe
    const standardQuantityInput = document.querySelector('quantity-input input[name="quantity"]');
    if (standardQuantityInput) {
      standardQuantityInput.disabled = true;
      console.log('Standard quantity input disabled');
    }
  }

  resetSelectedQuantity() {
    this.quantity_break_items.forEach((quantity_break) => {
      quantity_break.classList.remove('quantity-break--selected');
    });
  }

  getSelectedQuantity() {
    return this.querySelector('.quantity-break--selected');
  }

  getPrices() {
    const selectedQuantity = this.getSelectedQuantity();
    if (selectedQuantity) {
      return selectedQuantity.getPrices();
    }
    return null;
  }

  getSelectedItems() {
    let items = [];
    const selectedQuantity = this.getSelectedQuantity();

    if (selectedQuantity) {
      items.push({
        id: selectedQuantity.dataset.variantId,
        quantity: parseInt(selectedQuantity.dataset.quantity),
      });
    }

    return items;
  }

  dispatchQuantityUpdateEvent() {
    this.dispatchEvent(new CustomEvent('quantity-breaks:updated', {
      bubbles: true,
      detail: {
        quantity: this.getSelectedQuantity()?.dataset.quantity,
        prices: this.getPrices()
      }
    }));
  }

  onVariantUpdated(event) {
    // Mettre à jour les prix et images quand la variante change
    const currentQuantityBreaks = this;

    if (!currentQuantityBreaks) return;

    // Récupérer la nouvelle variante sélectionnée
    const variantId = event.detail?.variant?.id;

    if (variantId) {
      currentQuantityBreaks.querySelectorAll('[data-ref="quantity-break-item"]').forEach((item) => {
        item.dataset.variantId = variantId;
      });

      this.dispatchQuantityUpdateEvent();
    }
  }
}

customElements.define('quantity-breaks', QuantityBreaks);

class QuantityBreakItem extends HTMLElement {
  constructor() {
    super();

    this.price = null;
  }

  connectedCallback() {
    this.price = this.querySelector('[data-ref="quantity-break-price"]');
  }

  getPrices() {
    return {
      price: this.dataset.totalPrice,
      compareAtPrice: this.dataset.totalCompareAtPrice,
    };
  }

  updatePrice(newPrice, newCompareAtPrice) {
    this.dataset.totalPrice = newPrice;
    this.dataset.totalCompareAtPrice = newCompareAtPrice;

    if (this.price) {
      const priceElement = this.price.querySelector('[data-ref="price"]');
      const compareAtPriceElement = this.price.querySelector('[data-ref="compare-at-price"]');

      if (priceElement) {
        priceElement.textContent = this.formatMoney(newPrice);
      }

      if (compareAtPriceElement && newCompareAtPrice > newPrice) {
        compareAtPriceElement.textContent = this.formatMoney(newCompareAtPrice);
      } else if (compareAtPriceElement) {
        compareAtPriceElement.textContent = '';
      }
    }
  }

  formatMoney(cents) {
    // Utiliser le formatage Shopify si disponible, sinon formatage simple
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2) + ' €';
  }
}

customElements.define('quantity-break-item', QuantityBreakItem);
